var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h100 d-flex"},[_c('title-bar',[_vm._v("My Scored Matches")]),_c('v-main',{staticClass:"h100"},[_c('v-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('my-scored-matches')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }